/* eslint-disable no-param-reassign */
import _ from 'lodash';
import moment from 'moment';
import md5 from 'js-md5';
import codes from '../constants/code';
import oax from '../utils/oax';
import handler from '../utils/ErrorHandler';
import assets from '../data/authorityData';
import status from '../constants/status';
import msgs from '../data/msgs';

export default {
  data() {
    return {
      judgeCode: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'W', 'X'],
      levels: {
        A: '심사신청', P: '심사준비', J: '공장심사', C: '위원회심의', F: '심의후처리',
      },
    };
  },
  computed: {
    site() {
      return this.$route.params.site;
    },
    codes() {
      return codes;
    },
    oax() {
      return oax;
    },
    handler() {
      return handler;
    },
    isLogin() {
      return !!this.$store.state.authentication;
    },
    isFrontLogin() {
      return this.isLogin && this.authentication.role === 'C';
    },
    host() {
      return location.host;
    },
    scheme() {
      return location.protocol;
    },
    assets() {
      return assets;
    },
    authentication() {
      return this.$store.state.authentication;
    },
    personalInfo() {
      return this.$store.state.personalInfo;
    },
    short() {
      return this.$store.state.short === 'Y';
    },
    nowDate() {
      return moment().format('YYYY-MM-DD');
    },
    section() {
      const v = this.$route.path.split('/')[2];
      return v === 'admin' ? 'authority' : v;
    },
  },
  methods: {
    promiseMsg(msg, title, isConfirm) {
      const command = { msg, title, isConfirm };
      const promise = new Promise((resolve, reject) => {
        command.resolve = resolve;
        command.reject = reject;
      });
      this.$store.commit('simpleMsg', command);
      return promise;
    },
    alert(msg, title) {
      return this.promiseMsg(msg, title);
    },
    confirm(msg, title) {
      return this.promiseMsg(msg, title, true);
    },
    asset(key) {
      return assets[key][this.site];
    },
    statusFilter(level, ...add) {
      return _.uniq(_.map(_.filter(status, e => e.level === level), e => e.statusName)).concat(add || []);
    },
    values(...args) {
      return _.reduce(args, (acc, v) => { acc[v] = true; return acc; }, {});
    },
    statusParam(code) {
      return _.assign({ status: code }, status[code]);
    },
    appendStatusParam(obj, code) {
      obj.staus = code;
      return _.assign(obj, status[code]);
    },
    msg(key, param) {
      let m = msgs[key];
      if (!m) return '';
      m = m[this.site] || m;

      _.forEach(param, (v, k) => {
        m = m.replace(`{${k}}`, v);
      });
      m = m.replace(/{authority}/g, this.asset('name'));
      m = m.replace(/{account}/g, this.asset('msgBankAccount'));
      m = m.replace(/{footer}/g, this.asset('msgFooter'));
      return m;
    },
    fillFile(info) {
      _.forEach(_.groupBy(info.files, 'name'), (files, name) => {
        info[name] = { toString: () => 'FILE_INPUT_MODEL', exist: files };
      });
    },
    mapping(origin, clone) {
      _.forEach(clone, (v, k) => {
        if (origin[k] || origin[k] === 0) clone[k] = origin[k];
      });
    },
    newSpec(spec) {
      return spec.replace(/^!!!/, '<s class="round-new">N</s>');
    },
    newSpec2(spec) {
      return spec.replace(/^!!!/, '[추가]');
    },
    isEmpty(val) {
      return _.isEmpty(val);
    },
    sizeof(collection) {
      return _.size(collection);
    },
    enterToBr(str) {
      return str ? str.replace(/[\n\r]+/gi, '<br>') : '';
    },
    goAuthorityLink(key) {
      const obj = this.asset('links');
      if (!obj) {
        alert('준비중입니다.');
        return;
      }
      const url = obj[key];
      if (!url) {
        alert('준비중입니다.');
        return;
      }

      if (url.indexOf('http') === 0 || url.indexOf('/api/download') === 0) window.open(encodeURI(url));
      else this.$router.push(url);
    },
    getRandomKey() {
      return md5(`${+new Date() + Math.random()}`);
    },
    encodeURI(uri) {
      return encodeURI(uri);
    },
    storeSearchInfo() {
      this.$store.commit('storeSearchInfo', { path: this.$route.path, value: this.searchInfo });
    },
    restoreSearchInfo() {
      const info = this.$store.state.searchInfo[this.$route.path];
      if (info) this.searchInfo = info;
    },
    parseExamList(sampleDetail) {
      const t0 = JSON.parse(sampleDetail);
      let list;
      if (t0[0] && t0[0].list) list = t0;
      else list = _.map(t0, row => ({ spec: row.spec, list: [row] }));

      _.forEach(list, (s) => {
        _.forEach(s.list, (n) => {
          n.spec = s.spec;
        });
      });

      const flatten = _.flatten(_.map(list, s => s.list));
      const conflicts = _.some(_.countBy(flatten, s => s.spec + s.count), v => v > 1);

      if (conflicts) {
        _.forEach(flatten, s => s.filekey = md5(s.spec + s.count + s.no + s.lot));
      } else {
        _.forEach(flatten, s => s.filekey = md5(s.spec + s.count));
      }

      return list;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixin/index.js